module.exports = __webpack_public_path__ + "img/taiwan-travel.3b2c39db.svg";